import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Observable, catchError, tap, throwError } from "rxjs";
import { Injectable } from '@angular/core';
import { LocaleStorageService } from "../locale-storage.service";

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private localStorageService: LocaleStorageService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
      return next.handle(req).pipe(catchError(err => {
        if (err.status === 401 || err.status === 403 || err.status === 500) 
        {
            window.alert(err.status===401 ? "Your previous login has expired, please login again!" : 
            err.status===403 ? "Your are not authorized to perform this action!" : "Internal server Error, please contact your adminstrator!");
        }
          
        //goto login when login expired
        if (err.status===401)
        {
            this.localStorageService.clearData();
            location.reload();
        }

        const error = err.error ? err.error.message : err.statusText;
        return throwError(error);
      }))
  }
}